import { ServerClientEventSummary } from '../../signalr/models';
import { ClientEventSummaryHandlerBase, ClientEventSummaryHandlerBaseArgs } from '../../signalr/ClientEventSummaryHandlerBase';

export interface ServerClientEventSummaryHandlerArgs extends ClientEventSummaryHandlerBaseArgs<ServerClientEventSummary> {}

export class ServerClientEventSummaryHandler extends ClientEventSummaryHandlerBase<ServerClientEventSummary> {
    public constructor(server: string, args: ServerClientEventSummaryHandlerArgs) {
        super(server, args);
    }

    protected override isForMe(data: ServerClientEventSummary): boolean {
        return data.targetServer === this.server;
    }
}
